export default "__VITE_ASSET__BUL4iheA__"